import { useAppTranslation } from "@/utils";
import { Button, Drawer, Grid, Space } from "@payping/web-components";

type Props = {
  title: string;
  open: boolean;
  onClose: () => void;
  onClickResetFilters: () => void;
  onClickApplyFilters: () => void;
  loading?: boolean;
  children: any;
};
export const FiltersDrawer = (props: Props) => {
  const { md } = Grid.useBreakpoint();
  const { t } = useAppTranslation();

  return (
    <Drawer
      title={props.title}
      placement={md ? "left" : "bottom"}
      onClose={props.onClose}
      height={"100%"}
      width={md ? "33rem" : "100%"}
      open={props.open}
      extra={
        <Space>
          {/* < ResetFilters > */}
          <Button loading={props.loading} onClick={props.onClickResetFilters}>
            {t("resetForm")}
          </Button>
          {/* </ ResetFilters > */}

          {/* < ApplyFilters > */}
          <Button // loading={loading}
            loading={props.loading}
            type="primary"
            onClick={props.onClickApplyFilters}
          >
            {t("applyFilter")}
          </Button>
          {/* </ ApplyFilters > */}
        </Space>
      }
    >
      {props.children}
    </Drawer>
  );
};
